import React, { useState } from 'react';
import { graphql } from 'gatsby';
import _ from 'lodash';
import ChinaTeamFull from '../components/chinaTeam';
import SessionData from '../components/session-data';
import SEO from '../components/seo';
import Layout from '../containers/layout';
import ChinaFooter from '../components/chinaFooter';

export const query = graphql`
  query ChinaTeamTemplateQuery($id: String!) {
    home: sanityChinaHome {
        address1 {
            cn
            en
        }
        address2 {
            en
            cn
        }
        footerBlurb {
            cn
            en
        }
    }
    people: sanityChinaTeam(id: { eq: $id }) {
        slug {
            current
        }
        id
        name {
            en
            cn
        }
        publishedAt
        email
        linkedinUrl
        twitterUrl
        body {
            en
            cn
        }
        image {
            asset {
                _id
            }
        }
    }
  }
`;

const ChinaTeamTemplate = props => {
    const sessionLanguage = SessionData.getValue('language') || 'en';
    const [language, setLanguage] = useState(sessionLanguage);
    const { data, errors } = props;
    const people = _.get(data, 'people');

    const languages = {
        'en': {
            'changeLang': 'cn',
            'changeLabel': 'View in Chinese'
        },
        'cn': {
            'changeLang': 'en',
            'changeLabel': 'View in English'
        },
    }

    const toggleLanguage = (currentLanguage) => {
        setLanguage(currentLanguage);
        SessionData.setValue('language', currentLanguage);
    }

    return (
        <Layout>
        <SEO title={people.name[language]} defaultMicroData={true} />
        <a id="langSelect" onClick={() => toggleLanguage(languages[language].changeLang)}>{languages[language].changeLabel}</a>
        <ChinaTeamFull language={language} {...people} />
        <ChinaFooter language={language} data={data} />
        </Layout>
    );
};

export default ChinaTeamTemplate;
